import PropTypes from 'prop-types';
import { pagePropType as pageFieldsPropType } from '@glowforge/gf-styled/src/models/page';

// eslint-disable-next-line import/prefer-default-export
export const pagePropType = PropTypes.shape({
  fields: PropTypes.shape(pageFieldsPropType),
});
